<template>
    <div class="render-post-failed">
        <i class="fa-regular fa-circle-exclamation"></i>
        <p>{{ textError }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            textError: {
                type: String,
                default: ''
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>